function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#icon-radius_svg__clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.012 10.648a.648.648 0 110-1.297h9.976a9.924 9.924 0 00-2.907-6.421 9.992 9.992 0 00-14.139 0 9.992 9.992 0 000 14.139 9.992 9.992 0 0014.14 0 9.924 9.924 0 002.906-6.421h-9.976z",
  fill: "#0685FE"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "icon-radius_svg__clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h20v20H0z"
})));

function SvgIconRadius(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgIconRadius;